import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import Button from "@/components/Button";

function Card({ image,title, link }) {
    const [isInView, setIsInView] = useState(false);
    const ref = useRef(null);
    const [, year, educationalLevel] = title?.split(" ") || [];

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    observer.disconnect(); // Stop observing once it's in view
                }
            },
            { threshold: 0.9 }
        );

        const currentRef = ref.current;

        if (currentRef) {
            observer.observe(currentRef);
        }

        // Cleanup
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const buttonVariants = {
        offscreen: {
            y: -160,
            rotate: -20,
        },
        onscreen: {
            y: 0,
            rotate: 0,
            transition: {
                type: "spring",
                bounce: 0.8,
                duration: 1,
            },
        },
    };

    return (
        <div
            className="z-40 flex flex-col items-center justify-center gap-5"
            ref={ref}
        >
            <div className="flex items-center justify-center w-64 h-64 overflow-hidden border-8 rounded-full opacity-100 bg-primary-color-dark border-primary-color-primary">
                {/* {image && <Image loading="lazy" src={image} className="w-full" alt="test" />} */}
                {!image && (
                    <div className="flex flex-col items-center justify-center gap-5">
                        <p className="text-lg font-semibold text-white">الصف</p>
                        <div>
                            <img
                                src="/images/home/ClassIcon.webp"
                                alt="icon for design"
                                className="w-10 mx-auto"
                                loading="lazy"
                                decoding="async"
                            />
                            <Button
                                type="bordered"
                                className="text-white transition-colors duration-100 border-white rounded-md bg-primary-color-primary hover:bg-primary-color-dark"
                            >
                                {year}
                            </Button>
                        </div>
                        <p className="text-lg font-semibold text-white">
                            {educationalLevel}
                        </p>
                    </div>
                )}
            </div>
            <motion.div
                variants={buttonVariants}
                initial="offscreen"
                animate={isInView ? "onscreen" : "offscreen"}
                className="w-full"
            >
                <Button
                    type="customized"
                    to={link}
                    className="w-full px-5 py-3 font-medium text-center transition-colors duration-100 rounded-lg text-text-color-secondary bg-primary-color-primary hover:bg-primary-color-dark "
                >
                    {title}
                </Button>
            </motion.div>
        </div>
    );
}

export default Card;
